<template>
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="pointer trash-icon">
    <path d="M2 3.79932H3.4H14.6" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M5.49941 3.8V2.4C5.49941 2.0287 5.64691 1.6726 5.90947 1.41005C6.17202 1.1475 6.52811 1 6.89941 1H9.69942C10.0707 1 10.4268 1.1475 10.6894 1.41005C10.9519 1.6726 11.0994 2.0287 11.0994 2.4V3.8M13.1994 3.8V13.6C13.1994 13.9713 13.0519 14.3274 12.7894 14.5899C12.5268 14.8525 12.1707 15 11.7994 15H4.79941C4.42811 15 4.07202 14.8525 3.80946 14.5899C3.54691 14.3274 3.39941 13.9713 3.39941 13.6V3.8H13.1994Z" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M6.90039 7.30029V11.5003" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M9.69971 7.30029V11.5003" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>
</template>
<script>
export default {
    props: {
        size: {
            type: String,
            default: '16'
        },
        color: {
            type: String,
            default: '#A1A8B8'
        },
    }
}
</script>

<style>

</style>
